import { Button, ButtonVariation } from '../../../components/Button/Button';
import './UpdateRosterModal.css';

export enum RosterChangeType {
  REMOVE = 'remove',
  UPDATE = 'update',
}

export interface RosterChange {
  type: RosterChangeType;
  userName: string;
  date?: string;
  laborCategory?: string;
  riskLevel?: string;
}

interface UpdateRosterModalProps {
  changes: RosterChange[];
  onCancel: () => void;
  onDiscardChanges: () => void;
  onUpdateRoster: () => void;
}

function UpdateRosterModal({ changes, onCancel, onDiscardChanges, onUpdateRoster }: UpdateRosterModalProps) {
  const removals = changes.filter((change) => change.type === RosterChangeType.REMOVE);
  const updates = changes.filter((change) => change.type === RosterChangeType.UPDATE);
  const hasChanges = changes.length > 0;
  const baseTestId = 'update-roster-modal';

  return (
    <div
      className='update-roster-modal'
      data-testid={baseTestId}>
      {removals.length > 0 && (
        <>
          <p
            className='update-roster-modal__intro'
            data-testid={`${baseTestId}-removals-heading`}>
            The following users will be removed from this Roster:
          </p>
          <ul
            className='update-roster-modal__list'
            data-testid={`${baseTestId}-removals`}>
            {removals.map((change, index) => (
              <li key={`removal-${index}`}>
                {change.userName} will be removed on {change.date}.
              </li>
            ))}
          </ul>
        </>
      )}

      {updates.length > 0 && (
        <>
          <p
            className='update-roster-modal__intro'
            data-testid={`${baseTestId}-updates-heading`}>
            The following users will have their Labor Category updated:
          </p>
          <ul
            className='update-roster-modal__list'
            data-testid={`${baseTestId}-updates`}>
            {updates.map((change, index) => (
              <li key={`update-${index}`}>
                {change.userName} will be assigned as {change.laborCategory} with {change.riskLevel}.
              </li>
            ))}
          </ul>
        </>
      )}

      <p
        className='update-roster-modal__instruction'
        data-testid={`${baseTestId}-instruction`}>
        Click the "{hasChanges ? 'Update Roster' : 'Certify Roster'}" button to certify the Roster.
      </p>

      <div
        className='update-roster-modal__actions'
        data-testid={`${baseTestId}-actions`}>
        {hasChanges && (
          <Button
            isAutoWidth
            data-testid={`${baseTestId}-discard`}
            variation={ButtonVariation.GHOST}
            onClick={onDiscardChanges}>
            Discard Changes
          </Button>
        )}
        <Button
          isAutoWidth
          data-testid={`${baseTestId}-cancel`}
          variation={ButtonVariation.GHOST}
          onClick={onCancel}>
          Cancel
        </Button>
        <Button
          isAutoWidth
          data-testid={`${baseTestId}-confirm`}
          variation={ButtonVariation.SOLID}
          onClick={onUpdateRoster}>
          {hasChanges ? 'Update Roster' : 'Certify Roster'}
        </Button>
      </div>
    </div>
  );
}

export default UpdateRosterModal;
